module.exports = "https://static.wmbcdn.com/uniweb/images/bcca36dd0fe49bfa144fa9225491bd65.jpg";